export default __webpack_public_path__ + "static/6e9b738f02c65600d167b96a3a228c2f.png";